import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  cellRoot: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  contentStack: {
    '& > span': {
      display: 'block',
      '&:nth-of-type(2)': {
        color: theme.palette.text.secondary
      }
    }
  },
  icon: {
    fontSize: '22px',
    color: theme.palette.warning.main,
  },
}));
